import HomeImage from "../../assets/images/MM_2D_gold.png";
import "./Home.scss";
import { useRef, useState } from "react";
import initSqlJs from "sql.js";
import { useDispatch } from "react-redux";
import { setDb, setDatabaseLoaded } from "../../store/dbSlice";
import { useNavigate } from "react-router-dom";
import { decodeDatabaseFile } from "../../utils/dbFile";

function Home() {
  var fileInputEl = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const config = {
    locateFile: (filename: any) => `/${filename}`,
  };

  const loadDb = async (fileContent: Uint8Array) => {
    try {
      setError(null);
      const dbData = decodeDatabaseFile(fileContent);
      const SQL = await initSqlJs(config);
      const db = new SQL.Database(dbData);

      const tables = [
        "Clients",
        "MatrixDrops",
        "MeasureResultComputerDrop",
        "MeasureResultReceipt",
        "MeasureResults",
        "Visitations",
        "Problems",
        "Settings",
      ];

      tables.forEach((table) => {
        const rows = exportTable(db, table);
        dispatch(setDb({ key: table, data: rows }));
      });

      dispatch(setDatabaseLoaded(true));
      setIsLoading(false);
      navigate("/menu");
    } catch (error) {
      console.error("Error loading database:", error);
      setError(
        error instanceof Error
          ? error.message
          : "Failed to open the selected database."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const exportTable = (db, tablename) => {
    var stmt = db.prepare("SELECT * FROM " + tablename);
    var rows = [];

    while (stmt.step()) {
      const row = stmt.getAsObject();
      rows.push(row);
    }

    return rows;
  };

  const onNewFileSelected = (e: any) => {
    setError(null);
    const file = e.target.files[0];
    if (!file) return;

    setIsLoading(true);
    const reader = new FileReader();
    reader.onerror = () => {
      setError("The selected file could not be read by the browser.");
      setIsLoading(false);
    };
    reader.onload = () => {
      if (reader.result instanceof ArrayBuffer) {
        void loadDb(new Uint8Array(reader.result));
      } else {
        setError("The selected file could not be read as binary data.");
        setIsLoading(false);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const onLogoClicked = () => {
    if (fileInputEl !== null && fileInputEl.current !== null) {
      fileInputEl.current.click();
    }
  };

  return (
    <div className="home flex align-items-center justify-content-center">
      {isLoading === false && (
        <>
          <div>
            <img className="logo unselectable" src={HomeImage} alt="" onClick={onLogoClicked} />
          </div>
          <input
            type="file"
            name="dbfile"
            accept=".db"
            onChange={(e) => onNewFileSelected(e)}
            className="hidden"
            ref={fileInputEl}
          />
          {error && (
            <div
              className="error-message mt-3 p-3"
              style={{
                backgroundColor: "rgba(255, 0, 0, 0.8)",
                color: "white",
                borderRadius: "4px",
                maxWidth: "90%",
                textAlign: "center",
              }}
            >
              <i className="pi pi-exclamation-triangle mr-2"></i>
              {error}
            </div>
          )}
          {false && <i className="pi pi-replay text-xl" onClick={() => window.location.reload()}></i>}
        </>
      )}
      {isLoading && <i className="pi pi-spin pi-spinner text-3xl text-white"></i>}
    </div>
  );
}

export default Home;
